const apiRoutes = {
  ManageApp: `/gateway/appstore/api/ManageApp`,
  // ManageApp: "http://192.168.9.75:7000/api/ManageApp",
  AppFolder: `/gateway/appstore/api/ManageFolder`, // 文件夹
  // PageList:  API_CONFIG.APP_API_URL + "Firm/PageList"
  PageList: `/gateway/project/api/Firm/PageList`, // 部署列表
  SuperAdminUsers: `/gateway/project/api/Project/EnterpriseSuperAdmins`, // 部署邮箱
  Enterprise: `/gateway/project/api/Project/Enterprise`, // 部署项目
  Firm: `/gateway/project/api/Firm`, // 新增部署
  FirmDetail: `/gateway/project/api/Firm/Detail`, // 部署详细
};
export default apiRoutes;
